import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import type { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import type {
  RdapFormSectionUiOptions,
  RdapFormSectionValue,
} from '../../schemas/rdapFormSectionSchema';

export function RdapFormSectionField(
  props: FieldExtensionComponentProps<
    RdapFormSectionValue,
    RdapFormSectionUiOptions
  >,
) {
  const options = props.uiSchema?.['ui:options'];
  const showDivider = options?.divider !== false;

  return (
    <div className="rdap-form-section">
      {showDivider ? <Divider className="rdap-form-section__divider" /> : null}
      <Typography component="h2" variant="h6">
        {props.schema.title}
      </Typography>
      {options?.description ? (
        <Typography color="textSecondary" variant="body2">
          {options.description}
        </Typography>
      ) : null}
    </div>
  );
}
